import React, { useState } from 'react';

import styles from './CreditsManipulator.module.css';
import { creditsChangeType } from '../../../../../helpers/constants';

const creditsChangeTypeSymbols = {
  [creditsChangeType.INCREASE]: '+',
  [creditsChangeType.DECREASE]: '-'
};

export default ({
  level,
  label1,
  internalRecord,
  setInternalRecord,
  activePopup,
  parentWithLicence
}) => {
  const [creditsChangeTypePopup, setCreditsChangeTypePopup] = useState(
    creditsChangeType.INCREASE
  );
  const [creditsChangeValue, setCreditsChangeValue] = useState(0);

  const isForbiddenToSaveCredits =
    creditsChangeTypePopup === creditsChangeType.DECREASE &&
    creditsChangeValue > internalRecord.creditsLeft;

  const onCreditsChangeTypeSave = () => {
    if (!isForbiddenToSaveCredits) {
      const creditsChangeNotRounded =
        creditsChangeTypePopup === creditsChangeType.INCREASE
          ? creditsChangeValue
          : -1 * creditsChangeValue;
      const creditsChange = Math.round(creditsChangeNotRounded * 1000) / 1000;

      const newInternalRecord = {
        ...internalRecord
      };

      const newCreditsLeft =
        Math.round(
          ((newInternalRecord.creditsLeft || 0) + creditsChange) * 1000
        ) / 1000;
      newInternalRecord.creditsLeft = newCreditsLeft;
      let globalCreditsChange = creditsChangeType.NO_CHANGE;
      if (
        activePopup &&
        activePopup.record &&
        activePopup.record.creditsLeft > newInternalRecord.creditsLeft
      )
        globalCreditsChange = creditsChangeType.DECREASE;
      if (
        activePopup &&
        activePopup.record &&
        activePopup.record.creditsLeft < newInternalRecord.creditsLeft
      )
        globalCreditsChange = creditsChangeType.INCREASE;

      newInternalRecord.creditsChange = globalCreditsChange;
      newInternalRecord.creditsChangeAmount = Math.abs(
        (activePopup && activePopup.record && activePopup.record.creditsLeft
          ? activePopup.record.creditsLeft
          : 0) - (newInternalRecord.creditsLeft || 0)
      );

      if (level === 1) {
        if (
          globalCreditsChange === creditsChangeType.INCREASE ||
          globalCreditsChange === creditsChangeType.NO_CHANGE
        ) {
          const newCreditsAllocated =
            Math.round(
              (newInternalRecord.creditsAllocated + creditsChange) * 1000
            ) / 1000;
          newInternalRecord.creditsAllocated = newCreditsAllocated;
        }
      }

      if (level === 2) {
        const newCreditsAllocated =
          Math.round(
            (newInternalRecord.creditsAllocated + creditsChange) * 1000
          ) / 1000;
        newInternalRecord.creditsAllocated = newCreditsAllocated;
      }

      setInternalRecord(newInternalRecord);
    }
  };

  if (
    (level === 1 && internalRecord && internalRecord.licence) ||
    (level === 2 &&
      parentWithLicence &&
      (internalRecord && internalRecord.creditsAllocated !== null) &&
      internalRecord.creditsAllocated !== undefined)
  ) {
    return (
      <>
        <div className={styles.creditsLeftTopContainer}>
          <div className={styles.creditsLeftContainer}>
            {label1}:{' '}
            <span className={styles.creditValues}>
              {internalRecord.creditsAllocated || '0'}
            </span>
          </div>
          <div className={styles.creditsLeftContainer}>
            Credits left:{' '}
            <span className={styles.creditValues}>
              {internalRecord.creditsLeft || '0'}
            </span>
          </div>
        </div>
        <div className={styles.creditsLeftTopContainer}>
          <div className={styles.chargeTypePopupContainer}>
            {[creditsChangeType.INCREASE, creditsChangeType.DECREASE].map(
              (cT, i) => (
                <div
                  key={`charge-type-${i.toString()}`}
                  className={`${styles.chargeTypePopup} ${
                    creditsChangeTypePopup === cT
                      ? styles.chargeTypePopupActive
                      : null
                  }`}
                  role="presentation"
                  onClick={() => setCreditsChangeTypePopup(cT)}
                >
                  {creditsChangeTypeSymbols[cT]}
                </div>
              )
            )}
          </div>
          <input
            className={styles.creditsChangeInput}
            placeholder="0"
            value={creditsChangeValue || ''}
            onChange={e => {
              if (e.target.value && e.target.value !== '') {
                const newAllocatedValue = parseFloat(e.target.value, 10);
                setCreditsChangeValue(newAllocatedValue);
              } else {
                setCreditsChangeValue(0);
              }
            }}
            onKeyDown={evt =>
              evt.key === 'ArrowDown' ||
              evt.key === 'ArrowUp' ||
              evt.key === 'e' ||
              evt.key === 'E' ||
              evt.key === '-'
                ? evt.preventDefault()
                : null
            }
            onWheel={e => e.target.blur()}
            maxLength="6"
            type="number"
            spellCheck
          />
          <div
            className={
              isForbiddenToSaveCredits
                ? `${styles.creditsChangeSaveButton} ${styles.notActiveButton}`
                : styles.creditsChangeSaveButton
            }
            onClick={() => onCreditsChangeTypeSave()}
            role="presentation"
          >
            Save
          </div>
        </div>
      </>
    );
  }

  return null;
};
